import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MyAccountContent from "./component";
import { setProfileName, setEmail, setProfileMobile } from "../../au.configuration/actions";

const mapStateToProps = ({
    user: {
        profileName,
        email,
        mobile,
        secureToken,
        primaryIdentifierType,
        phoneNumberVerified,
        emailVerified
    }
}) => ({
    profileName,
    email,
    mobile,
    secureToken,
    primaryIdentifierType,
    phoneNumberVerified,
    emailVerified
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setProfileNameConnect: setProfileName,
    setEmailConnect: setEmail,
    setProfileMobileConnect: setProfileMobile
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountContent);
